import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'app-form-input-text',
    templateUrl: './form-input-text.component.html',
    encapsulation: ViewEncapsulation.Emulated
})
export class FormInputTextComponent {
    @Input() F: FormControl;
    @Input() ControlName: string;
    @Input() LabelString: string;
    @Input() RequiredMessage: string;
    @Input() PlaceHolder: string;
    @Input() id: string;
    @Input() type: string = "text";
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/form/form-input-text.component.ts